(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pf-black-november-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-bn-navigation')) {
    customElements.define('pf-bn-navigation', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.dataset.enhanced) return;
          const tabs = Array.from(this.querySelectorAll('[data-bn-tab]'));
          const panels = Array.from(this.querySelectorAll('[data-bn-panel]'));
          const tablist = this.querySelector('[data-bn-tabs]');
          if (!tablist || !tabs.length) return;
          const revealCurrent = panel => {
            const link = panel && panel.querySelector('[aria-current="page"]');
            const list = panel && panel.querySelector('.pf-bn-nav__links');
            if (!link || !list || list.scrollWidth <= list.clientWidth) return;
            const itemBounds = link.getBoundingClientRect();
            const listBounds = list.getBoundingClientRect();
            list.scrollLeft += itemBounds.left - listBounds.left - (list.clientWidth - itemBounds.width) / 2;
          };
          const activate = (tab, focus) => {
            tabs.forEach(item => {
              const selected = item === tab;
              item.setAttribute('aria-selected', String(selected));
              item.tabIndex = selected ? 0 : -1;
            });
            panels.forEach(panel => { panel.hidden = panel.dataset.bnPanel !== tab.dataset.bnTab; });
            if (focus) tab.focus();
            requestAnimationFrame(() => revealCurrent(panels.find(panel => panel.dataset.bnPanel === tab.dataset.bnTab)));
          };
          tablist.setAttribute('role', 'tablist');
          tabs.forEach((tab,index) => {
            const panel = panels.find(item => item.dataset.bnPanel === tab.dataset.bnTab);
            tab.setAttribute('role','tab');
            tab.setAttribute('aria-controls',panel.id);
            panel.setAttribute('role','tabpanel');
            panel.setAttribute('aria-labelledby',tab.id);
            tab.addEventListener('click',event => { event.preventDefault(); activate(tab,false); });
            tab.addEventListener('keydown',event => {
              let next;
              if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
              else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
              else if (event.key === 'Home') next = 0;
              else if (event.key === 'End') next = tabs.length - 1;
              else if (event.key === ' ') next = index;
              else return;
              event.preventDefault(); activate(tabs[next],true);
            });
          });
          this.dataset.enhanced = 'true';
          activate(tabs.find(tab => tab.dataset.bnTab === this.dataset.activeGroup) || tabs[0],false);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-dear-april-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('playfaire-stock-label')) {
    customElements.define('playfaire-stock-label', class extends HTMLElement {
      connectedCallback() {
        this.productRoot = this.closest('.product-detail');
        this.message = this.querySelector('[data-stock-message]');
        this.stock = JSON.parse(this.querySelector('[data-stock-variants]').textContent);
        this.onVariantChange = (event) => {
          if (!event.target.matches('[name="id"]')) return;
          const id = event.detail?.variant?.id || event.target.value;
          const inStock = this.stock[String(id)] === true;
          this.message.textContent = inStock ? this.dataset.inStock : this.dataset.availableToOrder;
          this.message.className = inStock ? 'live-indicator' : 'available-to-order';
        };
        this.productRoot?.addEventListener('change', this.onVariantChange);
      }
      disconnectedCallback() {
        this.productRoot?.removeEventListener('change', this.onVariantChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-supplier-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('playfaire-stock-label')) {
    customElements.define('playfaire-stock-label', class extends HTMLElement {
      connectedCallback() {
        this.productRoot = this.closest('.product-detail');
        this.message = this.querySelector('[data-stock-message]');
        this.stock = JSON.parse(this.querySelector('[data-stock-variants]').textContent);
        this.onVariantChange = (event) => {
          if (!event.target.matches('[name="id"]')) return;
          const id = event.detail?.variant?.id || event.target.value;
          const inStock = this.stock[String(id)] === true;
          this.message.textContent = inStock ? this.dataset.inStock : this.dataset.availableToOrder;
          this.message.className = inStock ? 'live-indicator' : 'available-to-order';
        };
        this.productRoot?.addEventListener('change', this.onVariantChange);
      }
      disconnectedCallback() {
        this.productRoot?.removeEventListener('change', this.onVariantChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
